module.exports = __webpack_public_path__ + "static/media/stepfive.2c879dad.gif";